import React from "react";
import { Card, Input, Select, Space, Typography } from "antd";
import {
  REQUEST_TYPE_OPTIONS,
  QUICK_REQUEST_TYPE_BLOCKS,
  ORDER_OPTIONAL_REQUEST_TYPES,
} from "../operationRequestConstants.js";
import PassengerNameChangeFields from "./PassengerNameChangeFields.jsx";
import OperationRequestDynamicFields from "./OperationRequestDynamicFields.jsx";
import styles from "./OperationRequestWorkspace.module.css";

const { Text } = Typography;
const { TextArea } = Input;

const ORDER_OPTIONAL_TYPE_OPTIONS = REQUEST_TYPE_OPTIONS.filter((o) =>
  ORDER_OPTIONAL_REQUEST_TYPES.has(o.value)
);

/**
 * @param {{
 *   requestType: string | null,
 *   onRequestTypeChange: (v: string | null) => void,
 *   hasLinkedOrder?: boolean,
 *   isNameChange: boolean,
 *   passengers: Array<Record<string, unknown>>,
 *   nameChangePassengerId: string | number | null,
 *   onNamePassengerChange: (v: string | number | null) => void,
 *   selectedNamePassenger: Record<string, unknown> | null,
 *   nameChangeNewFirst: string,
 *   nameChangeNewLast: string,
 *   onNameFirstChange: (s: string) => void,
 *   onNameLastChange: (s: string) => void,
 *   nameChangeFeePreview: { amountIls?: number | null, exchangeRateUsed?: number | null } | null,
 *   paymentRequired: boolean,
 *   onPaymentToggle: (v: boolean) => void,
 *   paymentDraft: Record<string, unknown>,
 *   setPaymentDraft: (fn: (p: any) => any) => void,
 *   message: string,
 *   onMessageChange: (s: string) => void,
 * }} props
 */
export default function OperationRequestFormCard({
  requestType,
  onRequestTypeChange,
  hasLinkedOrder = true,
  isNameChange,
  passengers,
  nameChangePassengerId,
  onNamePassengerChange,
  selectedNamePassenger,
  nameChangeNewFirst,
  nameChangeNewLast,
  onNameFirstChange,
  onNameLastChange,
  nameChangeFeePreview,
  paymentRequired,
  onPaymentToggle,
  paymentDraft,
  setPaymentDraft,
  message,
  onMessageChange,
}) {
  const typeOptions = hasLinkedOrder ? REQUEST_TYPE_OPTIONS : ORDER_OPTIONAL_TYPE_OPTIONS;

  return (
    <Card className={styles.surfaceCard} title="הגדרת הפנייה">
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <div>
          <span className={styles.formSectionLabel}>סוג פנייה</span>
          <Select
            allowClear
            size="large"
            placeholder="בחרו סוג פנייה"
            style={{ width: "100%" }}
            options={typeOptions}
            value={requestType ?? undefined}
            onChange={(v) => onRequestTypeChange(v ?? null)}
          />
          {requestType ? (
            <Text type="secondary" style={{ display: "block", marginTop: 8 }}>
              {QUICK_REQUEST_TYPE_BLOCKS.find((b) => b.value === requestType)?.label}
            </Text>
          ) : null}
          {!hasLinkedOrder ? (
            <Text type="secondary" style={{ display: "block", marginTop: 8 }}>
              פנייה כללית ללא הזמנה — ניתן לבחור כל סוג פנייה מהרשימה
            </Text>
          ) : null}
        </div>

        {isNameChange && hasLinkedOrder ? (
          <PassengerNameChangeFields
            passengers={passengers}
            nameChangePassengerId={nameChangePassengerId}
            onPassengerChange={onNamePassengerChange}
            selectedPassenger={selectedNamePassenger}
            nameChangeNewFirst={nameChangeNewFirst}
            nameChangeNewLast={nameChangeNewLast}
            onFirstChange={onNameFirstChange}
            onLastChange={onNameLastChange}
            feePreview={nameChangeFeePreview}
          />
        ) : hasLinkedOrder ? (
          <OperationRequestDynamicFields
            paymentRequired={paymentRequired}
            onPaymentToggle={onPaymentToggle}
            paymentDraft={paymentDraft}
            setPaymentDraft={setPaymentDraft}
          />
        ) : null}

        <div>
          <span className={styles.formSectionLabel}>
            {isNameChange && hasLinkedOrder ? "הודעה לאופרציה (אופציונלי)" : "הודעה לאופרציה *"}
          </span>
          <TextArea
            size="large"
            rows={isNameChange && hasLinkedOrder ? 4 : 6}
            maxLength={1000}
            showCount
            placeholder={
              isNameChange && hasLinkedOrder
                ? "הערות נוספות לאופרציה"
                : "פרט מה נדרש לבצע — שמות, תאריכים, סיבה וכו׳"
            }
            value={message}
            onChange={(e) => onMessageChange(e.target.value)}
          />
        </div>
      </Space>
    </Card>
  );
}
